module.exports = __webpack_public_path__ + "static/Baggage-second-iteration-1-591a5a6be7d3b0bc291607af4f8b0d01.png";